module.exports = __webpack_public_path__ + "files/checkered.7976b7df343a1730c2295b7441dd94dd.png";